import React from 'react';
import { connect } from "react-redux";
import SalesOrderMainComponent from './salesOrdersTab/SalesOrders.js';
import ItemMaster from './itemMaster/ItemMaster.js'
import ItemLot from './itemLotTab/ItemLotMainTab.js';
import HistoricalOrderTab from './historicalOrdersTab/HistoricalOrder.js';
import Allorderstab from './allOrdersTab/AllOrdersMainTab.js';
import EdiWebTab from './ediWebTab/EdiWebTab.js';
import CustomerSearchTab from './customerTab/customerSearchTab.js';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
const SalesOrderManagement = (props) => {
  return (
    <div>
      <TabPanel >
        <TabItem title="Sales Orders" style={{ paddingTop: '4px !important' }}>
          <SalesOrderMainComponent />
        </TabItem>
        <TabItem title="Historical Orders" style={{ paddingTop: '4px !important' }}>
          <HistoricalOrderTab />
        </TabItem>
        <TabItem title="All Orders" style={{ paddingTop: '4px !important' }}>
          <Allorderstab />
        </TabItem>
        <TabItem title="Item Master" style={{ paddingTop: '4px !important' }}>
          <ItemMaster />
          </TabItem>
          <TabItem title="Item/Lot" style={{ paddingTop: '4px !important' }}>
          <ItemLot />
          </TabItem>
        <TabItem title="Customers" style={{ paddingTop: '4px !important' }}>
          <CustomerSearchTab />
        </TabItem>
        <TabItem title="EDI/Web" style={{ paddingTop: '4px !important' }}>
          <EdiWebTab />
        </TabItem>
      </TabPanel>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(SalesOrderManagement);